<template>
  <div :class="$style.box">
    <div :class="$style.content">
      <div :class="$style.wrap">
        <div>
          为了给大家带来更好的论坛体验，我们将于3月17日进行论坛停运维护，预计维护时间为14:00-18:00，如未能按时完成，论坛开启时间将会顺延。
        </div>
        <div>给各位带来的不便，敬请谅解！</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='scss' module>
.box {
  width: 100vw;
  height: 100vh;
  padding: 0 10px;
  background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/announcement/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .content {
    width: 100%;
    height: 100vh;
    padding-top: 38vh;
    background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/announcement/text_bg.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    .wrap {
      width: 100%;
      height: 45vh;
      padding: 10px 30px;
      text-align: center;
      color: rgba(80, 80, 80, 1);
      > div:first-child {
        height: 60%;
        text-align: left;
        font-size: 14px;
        line-height: 28px;
        text-indent: 1.5em;
      }
      > div:last-child {
        text-align: center;
        font-weight: bold;
      }
    }
  }
}
</style>
